<template>
  <div class="rewards-table">
    <div class="rt-heading">
      <div class="rt-h-col">Campaign</div>
      <div class="rt-h-col">Reward Name</div>
      <div class="rt-h-col">Customer Email</div>
      <div class="rt-h-col">Earned Date</div>
      <div class="rt-h-col">Reward Code</div>
      <div class="rt-h-col">Use Date</div>
      <div class="rt-h-col">Action</div>
    </div>
    <div class="rt-body" v-if="result.length > 0" v-for="(item, index) in result" :key="index">
      <div class="rt-b-col"><h4>{{ item.post.name }}</h4></div>
      <div class="rt-b-col"><h4>{{ item.prize.name }}</h4></div>
      <div class="rt-b-col"><h4>{{ item.email }}</h4></div>
      <div class="rt-b-col">{{ item.earned_date ? item.earned_date : 'No record' }}</div>
      <div class="rt-b-col">{{ item.prize.code }}</div>
      <div class="rt-b-col">{{ item.prize.registered_date ? formatDate(item.prize.registered_date) : 'No record' }}</div>
      <div class="rt-b-col"></div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'RedeemedRewards',
  data () {
    return {
      result: []
    }
  },
  mounted () {
    this.getRewards()
  },
  methods: {
    formatDate (str) {
      return moment(new Date(str)).format('MM/DD/YYYY')
    },
    getRewards () {
      const payload = {
        type: 'redeemed'
      }
      this.$store.dispatch('getRewardsList', payload)
        .then((response) => {
          console.log('success', response)
          this.result = response.data.data
        })
        .catch(error => {
          console.log('error', error)
        })
    }
  }
}
</script>
